module.exports = __webpack_public_path__ + "img/logo.1b006a9d.png";